export default "__VITE_ASSET__ef54bbae__"